import React from "react";
// import * as d3KitGridmap from 'd3kit-gridmap'
// var d3KitGridmap = require('d3kit-gridmap');
import d3KitGridmap from 'd3kit-gridmap'
import { colorFillScale, colorTextScale } from "../utils/scale";
import { throttle } from 'throttle-debounce'
import { MAP_MAX_WIDTH, MAP_MIN_WIDTH} from '../config'
import {pymSendHeight} from '../utils/handlePym'


class GridMap extends React.Component {
  constructor(props) {
    super(props)

    /* We use throttle to minimize the number of times we check window size
    this is important for performance
    */
    this.throttledHandleWindowResize = throttle(300, this.resizeMap);
  }

  componentDidMount() {
    this.chart = this.initMap();
    window.addEventListener("resize", this.throttledHandleWindowResize);
    pymSendHeight()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledHandleWindowResize);
  }

  initMap() {
    const { width, tileWidth } = this.handleWidth();
    return new d3KitGridmap(this.refs.canvas, {
      col: d => d.x,
      row: d => d.y,
      fill: d => colorFillScale(d.status),
      textColor: d => colorTextScale(d.status),
      stroke: 'white',
      initialWidth: width,
      tileWidth: tileWidth,
      tileHeight: tileWidth,
      margin: { left: 5, right: 5 }
    })
      .data(this.props.data)
      .resizeToFitMap();
  }

  resizeMap = () => {
    const { width, tileWidth } = this.handleWidth();
    this.chart
      .options({
        tileWidth,
        tileHeight: tileWidth,
        margin: { left: 5, right: 5 }
      })
      .resizeToFitMap();
  };

  handleWidth = () => {
    const winWidth = window.innerWidth;
    let width;
    if (winWidth > MAP_MAX_WIDTH) {
      width = MAP_MAX_WIDTH;
    } else if (winWidth < MAP_MIN_WIDTH) {
      width = MAP_MIN_WIDTH;
    } else {
      width = winWidth;
    }
    width = width * 0.9;
    let tileWidth = width / 12;
    return { width, tileWidth };
  };

  render() {
    return (
      <div className="map__container">
        <div ref="canvas"></div>
      </div>
    );
  }
}

export default GridMap;
